import { Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import DatepickerStatic from '../../../../components/DatePickerStatic';
import GraphComp from '../../../../components/Graphs/GraphComp';
import { useSelector } from 'react-redux';
import moment from 'moment';
import appapi from '../../../../api/apiClient';
import { CancelToken } from 'apisauce';
import Graph from './Graph';
import SquareIcon from '@mui/icons-material/Square';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    placement="bottom-end"
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    maxwidth: '200px',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

export default function GraphActions() {
  const { t } = useTranslation();
  const { companyDetails, user } = useSelector((state) => state.auth);
  const [traderWiseData, setTraderWiseData] = useState([]);
  const [monthWiseData, setMonthWiseData] = useState([]);

  let source = CancelToken.source();
  let source2 = CancelToken.source();

  const [loading, setLoading] = useState(false);

  const gettraderWiseDetails = async (date) => {
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `/trader/portfolioTraderWiseGraph/${user?.companyId}`,
      {},
      {
        cancelToken: source.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setTraderWiseData(data?.response?.map(res => ({...res, name: res.traderName, Buy : res.buy?.toFixed(2), Sell: res.sell?.toFixed(2)})) || []);
        // setLoading(false)
      }
    }
  };

  const getMonthWiseDetails = async (date) => {
    source2.cancel();
    source2 = CancelToken.source();
    let year = date ? moment(new Date(date)).format("YYYY") : moment(new Date()).format("YYYY")
    const response = await appapi.get(
      `/trader/portfolioTraderMonthWiseGraph`,
      {
        companyId: user?.companyId,
        year : year
      },
      {
        cancelToken: source.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setMonthWiseData(data?.response?.map(res => ({...res, name: res.month, Buy : res.buy?.toFixed(2) , Sell: res.sell?.toFixed(2)})) || []);
        // setLoading(false)
      }
    }
  };

  useEffect(() => {
    initApi();
    return () => {
      if (source) {
        source.cancel();
      }
      if (source2) {
        source2.cancel();
      }
    };
  }, []);

  const initApi = async () => {
    setLoading(true);
    await gettraderWiseDetails();
    await getMonthWiseDetails();
    setLoading(false);
  };

  return (
    <Stack>
      <Stack
        flex={0.5}
      >
        <Stack style={{ borderBottomWidth: '1px', borderColor: 'rgba(188, 188, 188, 0.36)'}}>
          <Stack
            direction="row"
            style={{ height: '56px', justifyContent: 'space-between', alignItems: 'center', borderBottomWidth: '1px', borderColor: 'rgba(188, 188, 188, 0.36)', paddingRight: '16px'}}
          >
            <Typography style={{ fontSize: '14px', marginLeft: '15px', color: '#14285A', fontWeight: '600' }}>{t('EUA TRADED (%) TRADER WISE')}</Typography>
            <Stack
              direction="row"
              className="flex !justify-center !items-center !text-[#14285A40]"
            >
              <LightTooltip title={t('Show the % EUA traded from each trader')}>
                <HelpOutlineIcon className="!ml-[5px] !w-[17px] !h-[17px]" />
              </LightTooltip>
            </Stack>
          </Stack>
          {traderWiseData?.length > 0 &&
            <Stack direction="row" justifyContent={'flex-end'} className='!pr-[16px] !pt-[10px]  '>
              <Stack direction="row">
                <SquareIcon className='!text-[18px] !text-[#FFCC00]' />
                <Typography className='!text-[12px] !text-[#003399]'>
                {t('EUA Purchased')}
                </Typography>
              </Stack>
              <Stack direction="row" className='!ml-[20px]'>
                <SquareIcon className='!text-[18px] !text-[#003399]' />
                <Typography className='!text-[12px] !text-[#003399]'>
                {t('EUA Sold')}
                </Typography>
              </Stack>
            </Stack>}
          <Stack position="relative">
            <Graph
              graphData={traderWiseData}
              doubleGraph={true}
              isTraderGraph={true}
            />
          </Stack>
        </Stack>
      </Stack>
      <Stack flex={0.5}>
        <Stack >
          <Stack
            direction="row"
            style={{ height: '56px', justifyContent: 'space-between', alignItems: 'center', borderBottomWidth: '1px', borderColor: 'rgba(188, 188, 188, 0.36)', paddingRight: '16px'}}
          >
            <Typography style={{ fontSize: '14px', marginLeft: '15px', color: '#14285A', fontWeight: '600' }}>{t('EUA TRADED (%) MONTH WISE')}</Typography>
            <Stack
              direction="row"
              className="flex !justify-center !items-center !text-[#14285A40]"
            >
              <DatepickerStatic onlyear={true}  dateData={(date) => { getMonthWiseDetails(date) }}/>
              <LightTooltip title={t('Show the % EUA traded in each month in the given year')}>
                <HelpOutlineIcon className="!ml-[5px] !w-[17px] !h-[17px]" />
              </LightTooltip>
            </Stack>
          </Stack>
          {traderWiseData?.length > 0 &&
            <Stack direction="row" justifyContent={'flex-end'} className='!pr-[16px] !pt-[10px]  '>
              <Stack direction="row">
                <SquareIcon className='!text-[18px] !text-[#FFCC00]' />
                <Typography className='!text-[12px] !text-[#003399]'>
                {t('EUA Purchased')}
                </Typography>
              </Stack>
              <Stack direction="row" className='!ml-[20px]'>
                <SquareIcon className='!text-[18px] !text-[#003399]' />
                <Typography className='!text-[12px] !text-[#003399]'>
                {t('EUA Sold')}
                </Typography>
              </Stack>
            </Stack>}
          <Stack position="relative">
            <Graph
              graphData={monthWiseData}
              doubleGraph={true}
            />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
